export default __webpack_public_path__ + "static/media/index-based3.36955624.png";